<template>
  <footer class="landing-footer">
    <div class="container">
      <div class="footer-top">
        <div class="footer-brand">
          <img :src="logoWhite" alt="Hispano Medical Plan" class="footer-logo" />
          <p class="footer-text">
            Cuidamos tu salud y la de tu familia con planes médicos asequibles
            diseñados especialmente para la comunidad.
          </p>
          <router-link to="/patientflow" class="pf-link">
            <img :src="pfLogo" alt="" />
            <span>Programa de citas PatientFlow</span>
          </router-link>
        </div>

        <div class="footer-cols">
          <div>
            <h6 class="footer-subtitle">Planes</h6>
            <ul class="footer-links">
              <li><router-link to="/plans">Ver Planes</router-link></li>
              <li><router-link to="/#oportunidad">Oportunidad 2027</router-link></li>
              <li><router-link to="/#comparar">Comparar</router-link></li>
            </ul>
          </div>

          <div>
            <h6 class="footer-subtitle">Agentes</h6>
            <ul class="footer-links">
              <li>
                <a href="/providers#form-section" @click.prevent="goToProvidersForm">Únete</a>
              </li>
              <li><router-link to="/providers#agentes">Comisiones</router-link></li>
              <li>
                <a :href="pdfUrl" target="_blank" rel="noopener noreferrer">Presentación PDF</a>
              </li>
              <li><router-link to="/patientflow">PatientFlow</router-link></li>
            </ul>
          </div>

          <div>
            <h6 class="footer-subtitle">Contacto</h6>
            <ul class="footer-links">
              <li><i class="fas fa-phone"></i> (214) 888-9000</li>
              <li><i class="fas fa-envelope"></i> info@hispanomedicalplan.com</li>
              <li>
                <i class="fas fa-map-marker-alt"></i>
                6501 Preston rd, suite 100, Plano, Texas 75024
              </li>
              <li>
                <i class="fas fa-link"></i>
                <a href="https://bit.ly/CLocalidades" target="_blank" rel="noopener noreferrer">
                  https://bit.ly/CLocalidades
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <p class="footer-disc">{{ disclaimer }}</p>

      <div class="footer-bottom">
        <p class="copyright">
          © {{ currentYear }} Hispano Medical Plan. Todos los derechos reservados.
        </p>
        <div class="footer-legal-links">
          <a href="#privacy" class="footer-link">Política de Privacidad</a>
          <span class="mx-2">|</span>
          <a href="#terms" class="footer-link">Términos de Servicio</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import scrollToProvidersForm from '@/view/pages/landings/mixins/scrollToProvidersForm'
import { HMP_PRESENTATION_PDF, HMP_LEGAL_DISCLAIMER } from '@/view/pages/landings/data/hmpLinks2027'

export default {
  name: 'LandingFooter',
  mixins: [scrollToProvidersForm],
  data() {
    return {
      logoWhite: require('@/assets/lp/hmp/hmp-logo-blanco.png'),
      pfLogo: require('@/assets/lp/patientflow/patientflow-logo.png'),
      pdfUrl: HMP_PRESENTATION_PDF,
      disclaimer: HMP_LEGAL_DISCLAIMER
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../pages/landings/styles/variables';

.landing-footer {
  background: $landing-primary-color;
  color: #f3f7f8;
  padding: 64px 0 36px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;

  .container {
    position: relative;
    z-index: 2;
  }
}

.footer-top {
  display: grid;
  grid-template-columns: minmax(220px, 1.1fr) 1.6fr;
  gap: 40px;
  align-items: start;
}

.footer-logo {
  display: block;
  height: 52px;
  width: auto;
  margin-bottom: 1rem;
}

.footer-text {
  color: #b9cad6;
  line-height: 1.7;
  font-size: 0.95rem;
  margin-bottom: 1.25rem;
  max-width: 36ch;
}

.pf-link {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  color: #0b2f63;
  border-radius: 12px;
  padding: 10px 16px;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.9rem;

  img {
    height: 28px;
    width: auto;
  }

  &:hover {
    text-decoration: none;
    color: $landing-primary-color;
  }
}

.footer-cols {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}

.footer-subtitle {
  color: #cfe2ea;
  font-weight: 700;
  margin-bottom: 1.25rem;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  padding-bottom: 0.5rem;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 32px;
    height: 2px;
    background: rgba(255, 255, 255, 0.35);
    border-radius: 2px;
  }
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 0.65rem;
    font-size: 0.95rem;
    color: #b9cad6;

    a {
      color: #b9cad6;
      text-decoration: none;
      transition: color 0.2s ease;

      &:hover {
        color: #ffffff;
      }
    }

    i {
      margin-right: 0.75rem;
      color: #8fa8b8;
      font-size: 0.95rem;
      width: 20px;
      text-align: center;
    }
  }
}

.footer-disc {
  margin: 36px 0 0;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  color: #8fa8b8;
  font-size: 0.85rem;
  line-height: 1.55;
  max-width: 95ch;
}

.footer-bottom {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
  align-items: center;

  .copyright {
    color: #8fa8b8;
    margin: 0;
    font-size: 0.875rem;
  }

  .footer-link {
    color: #8fa8b8;
    text-decoration: none;
    font-size: 0.875rem;

    &:hover {
      color: #ffffff;
    }
  }

  .mx-2 {
    color: rgba(255, 255, 255, 0.25);
    margin: 0 0.75rem;
  }
}

@media (max-width: 900px) {
  .footer-top {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .footer-cols {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 576px) {
  .landing-footer {
    padding: 48px 16px 28px;
    padding-bottom: calc(28px + env(safe-area-inset-bottom, 0px));
  }

  .footer-cols {
    grid-template-columns: 1fr;
  }

  .footer-bottom {
    flex-direction: column;
    text-align: center;
  }

  .pf-link {
    width: 100%;
    justify-content: center;
  }
}
</style>
